import React, { useEffect } from "react";
import { connect } from "react-redux";
import { mediaUrl } from "../../../helpers/CoreHelpers";
import Modal from "../UI/Modal";
import styled from "styled-components";
import { get as getMedia } from "../../store/actions/media";

const ImageList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 25px;

  .img-option {
    height: 200px;
    width: 100%;
    background-position: center;
    background-size: cover;
    opacity: 1;
    transition: opacity 0.25s ease-in-out;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
`;

const ImageModal = (props) => {
  const {
    open,
    onChange,
    onClose,
    media: { items },
    getMedia,
  } = props;

  useEffect(() => {
    getMedia();
  }, []);

  return (
    <Modal title="Select image" icon="plus" showModal={open} onClose={onClose}>
      <ImageList>
        {items.map((o) => (
          <div
            key={o.id}
            onClick={(e) => {
              e.preventDefault();
              onChange(o);
            }}
            style={{ backgroundImage: `url(${mediaUrl(o)})` }}
            className="img-option"
          ></div>
        ))}
      </ImageList>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  media: state.media,
});

const mapDispatchToProps = {
  getMedia,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageModal);



// WEBPACK FOOTER //
// ./src/core/admin/components/CardGrid/ImageModal.js